import { render, staticRenderFns } from "./organizerInfo.vue?vue&type=template&id=0e0ba711&scoped=true&"
import script from "./organizerInfo.vue?vue&type=script&lang=js&"
export * from "./organizerInfo.vue?vue&type=script&lang=js&"
import style0 from "./organizerInfo.vue?vue&type=style&index=0&id=0e0ba711&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0ba711",
  null
  
)

export default component.exports